import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
} from "@mui/material";
import Switch from "@mui/material/Switch";
import React, { useEffect, useState } from "react";
import { useNavigate,useSearchParams } from "react-router-dom";
import useIsMobile from "../Hooks/useIsMobile";
import apiService from "../Services/api.service";
import CustomButton from "../components/Button";
import CustomCardList from "../components/Cards";
import PageLoader from "../components/Loader";
import Title from "../components/PageTitle";
import CustomTable from "../components/Table";
import { useToast } from "../components/Toast";
const Kiosk = () => {
  const Toast = useToast();
    const [searchParams, setSearchParams] = useSearchParams();
   const [searchQuery, setSearchQuery] = useState(searchParams.get("q") || "");
  const [filteredDoctors, setFilteredDoctors] = useState([]);
  const [page, setPage] = useState(Number(searchParams.get("page")) || 1);
    const [rowsPerPage, setRowsPerPage] = useState(
      Number(searchParams.get("limit")) || 10
    );
  const [totalCount, setTotalCount] = useState(0); // Total number of doctors (for pagination)
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [kiosk, setKiosk] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const auth = localStorage.getItem("token");
  const [typingTimeout, setTypingTimeout] = useState(null);
  const updateURLParams = (newFilters) => {
    setSearchParams({
      q: newFilters.searchQuery || "",
      page: newFilters.page || 1,
      limit: newFilters.rowsPerPage || 10,
    });
  };
    useEffect(() => {
      updateURLParams({
        searchQuery,
        page,
        rowsPerPage,
      });
    }, [searchQuery, page, rowsPerPage]);
  useEffect(() => {
    getKiosk(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const getKiosk = async (page, limit) => {
    setIsLoading(true);
    try {
      const { mappedDoctors, count } = await apiService.fetchKiosk(
        auth,
        page,
        limit
      );
      setKiosk(mappedDoctors);
      setFilteredDoctors(mappedDoctors);
      setTotalCount(count); // Set the total count
      setIsLoading(false);
    } catch (error) {
      Toast.error("Error while Fetching");
    } finally {
      setIsLoading(false);
    }
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage + 1); // Set the new page
  };
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10)); // Update rows per page when changed
    setPage(1); // Reset to page 1 when rows per page change
  };
  useEffect(() => {
    if (typingTimeout) clearTimeout(typingTimeout);

    const timeout = setTimeout(async () => {
      try {
        const { mappedDoctors, count } = await apiService.fetchKiosk(
          auth,
          page,
          10,
          searchQuery
        );
        setTotalCount(count);

        setFilteredDoctors(mappedDoctors);
      } catch (error) {
        console.error("Error fetching Kiosk:", error);
        Toast.error("Error while Fetching");
      }
    }, 500); // 500ms debounce

    setTypingTimeout(timeout);

    // Cleanup
    return () => clearTimeout(timeout);
  }, [searchQuery, page]);

  const handleSearch = (event) => {
    const keyword = event.target.value.toLowerCase();
    setSearchQuery(keyword); // Only set the query
  };
  const fields = [
    { label: "Clinic Name", key: "clinicName" },
    { label: "Location", key: "location" },
  ];

  const columns = [
    {
      field: "clinicName",
      headerName: "Clinic",
      align: "center",
    },
    {
      field: "doctorName",
      headerName: "Doctor",
      align: "center",
    },
    {
      field: "name",
      headerName: "Kiosk",
      align: "center",
    },
    // {
    //   field: "id",
    //   headerName: "kiosk Id",
    //   align: "center",
    // },
    {
      field: "location",
      headerName: "Location",
      align: "center",
    },
    {
      field: "inactivity",
      headerName: "Status",
      align: "center",
      renderCell: (value, row) => (
        <Switch
          checked={row.inactivity === "active"}
          onChange={() => handleToggleAccess(row)}
          color="primary"
        />
      ),
    },
    {
      field: "status",
      headerName: "Activation",
      align: "center",
      renderCell: (value) => {
        const status = value; // Get the value from the params object
        const styles = getStatusStyles(status); // Get the styles based on the status

        return (
          <span
            style={{
              display: "inline-block",
              padding: "4px 8px",
              borderRadius: "4px",
              fontWeight: "bold",
              ...styles, // Spread the styles from getStatusStyles
            }}
          >
            {value}
          </span>
        );
      },
    },

    // {
    //   field: "shipStatus",
    //   headerName: "Ship status",
    //   align: "center",
    //   renderCell: (value) => {
    //     const status = value; // Get the value from the params object
    //     const styles = getShipmentStatusStyles(status); // Get the styles based on the status

    //     return (
    //       <span
    //         style={{
    //           display: "inline-block",
    //           padding: "4px 8px",
    //           borderRadius: "4px",
    //           fontWeight: "bold",
    //           ...styles, // Spread the styles from getStatusStyles
    //         }}
    //       >
    //         {value}
    //       </span>
    //     );
    //   },
    // },
  ];

  const detailsClick = (
    id,
    kioskName,
    ClinicName,
    location,
    code,
    status,
    shipStatus
  ) => {
    navigate(`/dashboard/kiosk/kioskDetails/${id}`, {
      state: { id, kioskName, ClinicName, location, code, status, shipStatus },
    });
  };
  const ActivationStatus = {
    NOTACTIVATED: "not activated",
    TEMPORARY: "temporary activated",
    FULLY_ACTIVE: "fully activated",
    DISABLED: "disabled",
  };
  const ShipmentStatus = {
    PENDING: "pending",
    SHIPPED: "shipped",
    IN_TRANSIT: "in transit",
    DELIVERED: "delivered",
    CANCELED: "canceled",
    RETURNED: "returned",
    DELAYED: "delayed",
    ONHOLD: "on hold",
  };
  const getStatusStyles = (status) => {
    switch (status) {
      case ActivationStatus.NOTACTIVATED:
        return { backgroundColor: "#f8d7da", color: "#721c24" };
      case ActivationStatus.TEMPORARY:
        return { backgroundColor: "#fff3cd", color: "#856404" };
      case ActivationStatus.FULLY_ACTIVE:
        return { backgroundColor: "#d4edda", color: "#155724" };
      case ActivationStatus.DISABLED:
        return { backgroundColor: "#d6d8db", color: "#6c757d" };
      default:
        return { backgroundColor: "#f8f9fa", color: "#6c757d" };
    }
  };

  const getShipmentStatusStyles = (status) => {
    switch (status) {
      case ShipmentStatus.PENDING:
        return { backgroundColor: "#fff3cd", color: "#856404" };
      case ShipmentStatus.SHIPPED:
        return { backgroundColor: "#d1ecf1", color: "#0c5460" };
      case ShipmentStatus.IN_TRANSIT:
        return { backgroundColor: "#cce5ff", color: "#004085" };
      case ShipmentStatus.DELIVERED:
        return { backgroundColor: "#d4edda", color: "#155724" };
      case ShipmentStatus.CANCELED:
        return { backgroundColor: "#f8d7da", color: "#721c24" };
      case ShipmentStatus.RETURNED:
        return { backgroundColor: "#f5c6cb", color: "#842029" };
      case ShipmentStatus.DELAYED:
        return { backgroundColor: "#ffe8a1", color: "#856404" };
      case ShipmentStatus.ONHOLD:
        return { backgroundColor: "#e2e3e5", color: "#6c757d" };
      default:
        return { backgroundColor: "#f8f9fa", color: "#6c757d" };
    }
  };
  const handleToggleAccess = async (kiosk) => {
    const updatedStatus = kiosk.inactivity === "active" ? "disabled" : "active";

    const payload = {
      _id: kiosk.id,
      status: updatedStatus,
    };

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_HOST_URL}/ops/v1/kiosks/update`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${auth}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Network response was not ok");

      Toast.success(`Kiosk ${updatedStatus} successfully`);
      getKiosk(page, rowsPerPage); // Refresh
    } catch (error) {
      Toast.error("Failed to update access");
      console.error("Update error:", error);
    }
  };

  return (
    <div>
      <Paper sx={{ padding: 2 }}>
        <Title text="Kiosk" />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            marginBottom: 2,
          }}
        >
          <TextField
            label="Search"
            variant="outlined"
            value={searchQuery}
            onChange={handleSearch}
            fullWidth
            sx={{ marginBottom: 2, marginTop: 3 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        {isMobile ? (
          // Card layout for mobile
          <CustomCardList
            page={page - 1} // Adjust for zero-based indexing for `CustomTable`
            rowsPerPage={rowsPerPage}
            totalCount={totalCount}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            fields={fields}
            data={filteredDoctors}
            onCardClick={(doctor) =>
              detailsClick(
                doctor.id,
                doctor.name,
                doctor.clinicName,
                doctor.location,
                doctor.code,
                doctor.status,
                doctor.shipStatus
              )
            }
          />
        ) : (
          <CustomTable
            columns={columns}
            data={filteredDoctors}
            actions={[
              {
                Component: CustomButton,
                props: { text: "Details", width: "90px", height: "40px" },
                onClick: (row) =>
                  detailsClick(
                    row.id,
                    row.name,
                    row.clinicName,
                    row.location,
                    row.code,
                    row.status,
                    row.shipStatus
                  ),
              },
            ]}
            page={page - 1} // Adjust for zero-based indexing for `CustomTable`
            rowsPerPage={rowsPerPage}
            totalCount={totalCount}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        )}
      </Paper>
      {isLoading && <PageLoader />}
    </div>
  );
};
export default Kiosk;
